import { useState } from 'react';
import { FastField } from 'formik';
import { Stack } from '@koob/margaret';
import { KoobFormikInput } from '@koob/ui';
import { FormField, FormLabel, ErrorMessageWrapper } from 'ui/forms';
import { uniqueId } from 'lodash';

const FastTextField = ({
  label,
  labelSuffix,
  name,
  variant,
  validate,
  ...props
}) => {
  const [id] = useState(uniqueId());

  const renderInput = ({ field, form }, hasError) => (
    <KoobFormikInput
      field={field}
      setValue={(value) => form.setFieldValue(field.name, value)}
      {...props}
      error={hasError}
      id={id}
    />
  );

  if (variant === 'inline') {
    return (
      <FastField name={name} validate={validate}>
        {({ field, meta, form }) => {
          const hasError = Boolean(meta.touched) && Boolean(meta.error);

          return (
            <Stack alignY="center" gutterSize={0.5}>
              <FormLabel variant="bare" htmlFor={id}>
                {label}
              </FormLabel>
              <Stack>{renderInput({ field, form }, hasError)}</Stack>
            </Stack>
          );
        }}
      </FastField>
    );
  }

  return (
    <FormField>
      {(Boolean(label) || Boolean(labelSuffix)) && (
        <Stack
          alignX="space-between"
          alignY="center"
          marginBottom={0.5}
          size="full"
        >
          {Boolean(label) && (
            <FormLabel variant="bare" htmlFor={id}>
              {label}
            </FormLabel>
          )}
          {labelSuffix}
        </Stack>
      )}

      <Stack size="full">
        <FastField name={name}>
          {({ field, meta, form }) => {
            const hasError = Boolean(meta.touched) && Boolean(meta.error);

            return (
              <div style={{ width: '100%' }}>
                {renderInput({ field, form }, hasError)}
                {hasError && (
                  <ErrorMessageWrapper>{meta.error}</ErrorMessageWrapper>
                )}
              </div>
            );
          }}
        </FastField>
      </Stack>
    </FormField>
  );
};

export default FastTextField;
